//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactWhitepaper from '~/mixins/contact/whitepaper.js'
import SubscribeEmail from '~/mixins/subscribe/email'
import { WHITEPAPER_LIST_ID } from '~/constants/klaviyo'

export default {
  mixins: [ContactWhitepaper, SubscribeEmail],
  data () {
    return {
      form: {
        fields: {
          firstName: {
            value: ''
          },
          lastName: {
            value: ''
          },
          email: {
            value: '',
            type: 'email'
          },
          company: {
            value: ''
          }
        }
      }
    }
  },
  computed: {
    fields () {
      return this.$t('whitepaper.contact.form.fields')
    }
  },
  methods: {
    async onSubmit () {
      const slackText = Object.keys(this.form.fields).reduce((accum, current) => `${accum}${current}: ${this.form.fields[current].value}\n`, '')
      const data = {
        blocks: [
          {
            type: 'header',
            text: {
              type: 'plain_text',
              text: 'Company form submited'
            }
          },
          {

            type: 'context',
            elements: [
              {
                type: 'mrkdwn',
                text: slackText
              }
            ]
          }
        ]
      }
      const pdfUrl = this.getStaticsObject('/How-Personalization-Lab-Testing-Can-Solve-Employee-Engagement-Problem.pdf')
      window.open(pdfUrl, '_blank')
      await this.sendWhitepaperContactForm(data)
      await this.subscribeEmail({ email: this.form.fields.email.value, listID: WHITEPAPER_LIST_ID })
      this.$toast.success(this.$t('business.contactForm.form.toast.success').toString())
      Object.keys(this.form.fields).forEach((field) => {
        this.form.fields[field].value = ''
      })
    }
  }
}
